<template>
  <div class="content">
    <div class="box">
      <div class="search">
        <div style="display: flex;align-items: center">
          <div style="cursor: pointer" @click="goBack"><img src="../../../assets/image/back.png"></div>
          <div style="display: flex;align-items: center">
            <p style="width: 4vw">姓名</p>
            <el-input size="small" placeholder="请输入姓名" ></el-input>
          </div>
          <div style="display: flex;align-items: center">
            <p style="width: 4vw">名称</p>
            <el-input size="small" placeholder="请输入单位名称" ></el-input>
          </div>
          <div style="display: flex;align-items: center;margin-right: 10px">
            <p style="width: 4vw">类型</p>
            <el-select size="small" v-model="watchType">
              <el-option label="未观看" :value="0"></el-option>
              <el-option label="已观看" :value="1"></el-option>
            </el-select>
          </div>
          <span class="button" @click="select">查询</span>
        </div>
        <div style="display:flex">
          <span class="button" style="margin-right:8px" @click="downloadExamVideoStatisTemplate">下载模板</span>
           <el-upload
                  ref="upload"
                  action="https://sites.tongsheng01.com/examVideoGroup/importExamVideo"
                  :headers="uploadHead"
                  :data="uploadData"
                  :on-success="success"
                  :show-file-list="false">
                <span class="button" style="margin-right:8px" >导入</span>
              </el-upload>
          <span class="button" @click="exportExcel">导出</span>
        </div>
      </div>
      <el-table :data="tableData" stripe height="76vh">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{scope.row.index}}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位名称">
          <template slot-scope="scope">
            <span>{{scope.row.entName}}</span>
          </template>
        </el-table-column>
         <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
         <el-table-column label="观看时间">
          <template slot-scope="scope">
            <span>{{scope.row.create_date}}</span>
          </template>
        </el-table-column>
         <el-table-column label="结束时间">
          <template slot-scope="scope">
            <span>{{scope.row.update_date}}</span>
          </template>
        </el-table-column>
         <el-table-column label="时长">
          <template slot-scope="scope">
            <span>{{scope.row.duration}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <el-dialog
      title="错误提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>{{msg}}</span>
      <span>{{msgData}}</span>
    </el-dialog>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        projectId: '',
        pageNum: 1,
        pageSize: 20,
        total: 0,
        tableData: [],
      
      entName:'',
        videoId: '',
        entId: '',
         uploadHead: {
          accessToken: util.session.get('token')
        },
        uploadData: {
          projectId:util.session.get('groupId'),
          videoId:'',
          createBy:util.session.get('user').id
        },
        msg:'',
        dialogVisible:false,
        msgData:'',
      }
    },
    created() {
      const {videoId, entId} = this.$route.query
      this.videoId = videoId
      this.entId = entId
      this.projectId = util.session.get('groupId')
      this.getData()
    },
    methods: {
      success(val){
        if(val.code==200){
          this.getData()
          this.$message({
            type:'success',
            message:val.msg
          })
        }else{
          this.dialogVisible=true
          this.msg = val.msg
          if(val.data){
            this.msgData = val.data
          }
        }
      },
      downloadExamVideoStatisTemplate(){
      var token = util.session.get('token')
      window.open(myHttp.downloadExamVideoStatisTemplate+'?accessToken='+token)
      },
       handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      select(){
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },

      getData(){
        myHttp.selectListByEntAndProjectIdAndType({
          videoId: this.videoId,
          groupId: this.entId,
          watchType: this.watchType,
          
          projectId: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const list = resp.data.data.examVideoProjectList.list
            for(let i=0;i<list.length;i++){
              list[i].index = (this.pageNum - 1) * this.pageSize + 1 + i
              // console.log(list[i].duration)
              list[i].duration = util.myTime.setSzHMS(list[i].duration)
            }
            this.uploadData.videoId=this.videoId
            this.tableData = list
            this.total = resp.data.data.examVideoProjectList.total
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      exportExcel(){
        const token = util.session.get('token')
        window.open(
          base.url + '/examVideoGroup/exportListByEntAndProjectIdAndType?accessToken=' + token + '&videoId=' + this.videoId + '&groupId=' + 
          this.entId + '&watchType=' + this.watchType + '&projectId=' + this.projectId + '&pageSize=' + this.pageSize + '&pageNum=' + this.pageNum
        )
      },

      goBack(){
        this.$router.go(-1)
      }
    },
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.content{
  padding: 1vh 1vw;
}
.box{
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.search{
  padding: 12px 18px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #D8D8D8;
}
.content >>> .el-pagination{
  border-radius: 0 0 6px 6px;
}
</style>